import styled from "@emotion/styled";

const Wrapper = styled.div`
  margin-bottom: 96px;
  display: flow-root;
  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    /* 48px of its own plus the 16px the removed ContentMobileFullscreen
       contributed inside it — flow-root stops the two collapsing. */
    margin-bottom: ${({ theme }) => theme.space.space64};

    .swiper-slide {
      &:first-of-type {
        padding-left: 20px;
      }
    }
  }
`;

export { Wrapper };
